import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField } from '@material-ui/core';
import { api } from 'src/service';

// Two dependent dropdowns: concelho → freguesia, populated from
// /backoffice/regions (which reads service_region_boundaries).
// Pass `value` ({concelho, freguesia}) and `onChange` to wire it in.
const RegionSelector = ({ value, onChange, label }) => {
  const [concelhos, setConcelhos] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    api
      .get('/backoffice/regions')
      .then((res) => {
        if (!mounted) return;
        const list = (res && res.data && res.data.data && res.data.data.concelhos) || [];
        setConcelhos(list);
        setLoaded(true);
      })
      .catch(() => {
        if (mounted) setLoaded(true);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const current = value || { concelho: '', freguesia: '' };
  const freguesias =
    (concelhos.find((c) => c.concelho === current.concelho) || {}).freguesias || [];

  const setConcelho = (e) => {
    onChange({ concelho: e.target.value, freguesia: '' });
  };
  const setFreguesia = (e) => {
    onChange({ ...current, freguesia: e.target.value });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          select
          SelectProps={{ native: true }}
          label={label ? `${label} — Municipality` : 'Municipality (concelho)'}
          value={current.concelho}
          onChange={setConcelho}
          variant="outlined"
          disabled={!loaded}
        >
          <option value="">— All / none —</option>
          {concelhos.map((c) => (
            <option key={c.concelho} value={c.concelho}>
              {c.concelho}
            </option>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          select
          SelectProps={{ native: true }}
          label="Parish (freguesia, optional)"
          value={current.freguesia}
          onChange={setFreguesia}
          variant="outlined"
          disabled={!current.concelho || freguesias.length === 0}
        >
          <option value="">— Whole municipality —</option>
          {freguesias.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};

RegionSelector.propTypes = {
  value: PropTypes.shape({
    concelho: PropTypes.string,
    freguesia: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default RegionSelector;
